/* eslint-disable camelcase */

import { createAction, handleAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const formatAddressForValidation = (addressValues) => {
  const shippingAddress = Object.assign({}, addressValues, { country: 'USA', postalCode: addressValues.zip });
  delete shippingAddress.zip;
  return shippingAddress;
};

export const formatAddressForSaving = (addressValues) => {
  const shippingAddress = Object.assign({}, addressValues, { country: 'US', address: addressValues.address1 });
  delete shippingAddress.address1;
  return shippingAddress;
};

export const validateAddress = createAction('VALIDATE_ADDRESS', (address) => {
  return getDataProvider().validateAddress(formatAddressForValidation(address));
});

export const saveShippingAddress = createAction('SAVE_SHIPPING_ADDRESS', (address) => {
  return getDataProvider().saveShippingAddress(formatAddressForSaving(address));
});

export const setShippingAddress = createAction('SET_SHIPPING_ADDRESS');

export default handleAction(setShippingAddress, (state, action) => {
  return { ...action.payload };
}, null);
